var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32855 12.0922L12.4986 3.92212C12.6576 3.76317 12.7837 3.57447 12.8697 3.3668C12.9557 3.15912 13 2.93653 13 2.71174C13 2.48695 12.9557 2.26436 12.8697 2.05669C12.7837 1.84901 12.6576 1.66031 12.4986 1.50136C12.3397 1.34241 12.151 1.21632 11.9433 1.1303C11.7356 1.04428 11.513 1 11.2883 1C11.0635 1 10.8409 1.04428 10.6332 1.1303C10.4255 1.21632 10.2368 1.34241 10.0779 1.50136L1.90779 9.67145M4.32855 12.0922L1 13L1.90779 9.67145M4.32855 12.0922L3.11817 10.8818L1.90779 9.67145",
    stroke: "#7D899D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.986622f8.svg";
export { ForwardRef as ReactComponent };